// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"f7a3b7ab","167":"5956d226","559":"c70f4f7b","812":"0d3c45b9","896":"f7a3b7ab"}[chunkId] + ".chunk.css";
};